import React from "react";

const CardComponent = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <div
            className="card mt-5 shadow"
            style={{
              backgroundColor: "#0A6847",
              color: "aliceblue",
              fontSize: "19px",
              fontWeight: "680",
            }}
          >
            <h5
              className="card-header"
              style={{
                fontSize: "25px",
                fontWeight: "680",
              }}
            >
              Isolation des murs par l'extérieur
            </h5>
            <div className="card-body">
              <h5
                className="card-title"
                style={{
                  fontSize: "23px",
                  fontWeight: "680",
                }}
              >
                Qualibat
              </h5>
              <p
                className="card-text"
                style={{
                  backgroundColor: "#0A6847",
                  color: "aliceblue",
                  fontSize: "19px",
                  fontWeight: "680",
                }}
              >
                Isolation thermique par l'extérieur (Technicité courante)
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardComponent;
